import { MetadataStore } from 'breeze-client';

import { Account } from './account';
import { AccountAddress } from './account-address';
import { AccountAdmin } from './account-admin';
import { AccountAdminGroup } from './account-admin-group';
import { AccountAdminGroupMap } from './account-admin-group-map';
import { AccountBudget } from './account-budget';
import { AccountConsolidation } from './account-consolidation';
import { AccountConsolidationDecision } from './account-consolidation-decision';
import { AccountConsolidationItem } from './account-consolidation-item';
import { AccountConsolidationItemType } from './account-consolidation-item-type';
import { AccountConsolidationStatus } from './account-consolidation-status';
import { AccountGuidelineException } from './account-guideline-exception';
import { AccountImage } from './account-image';
import { AccountImport } from './account-import';
import { AccountImportCodeOption } from './account-import-code-option';
import { AccountIssuance } from './account-issuance';
import { AccountIssuanceUserGroupMap } from './account-issuance-user-group-map';
import { AccountIssuanceUserLog } from './account-issuance-user-log';
import { AccountProcurementCard } from './account-procurement-card';
import { AccountProcurementCardLog } from './account-procurement-card-log';
import { AccountPurchaseOrder } from './account-purchase-order';
import { AccountPurchaseOrderLog } from './account-purchase-order-log';
import { AccountUser } from './account-user';
import { AccountUserAllowanceLog } from './account-user-allowance-log';
import { ActiveStatus } from './active-status';
import { Addon } from './addon';
import { AddonImage } from './addon-image';
import { ApiCombinePair } from './api-combine-pair';
import { ApprovalTree } from './approval-tree';
import { ApprovalTreeAdminGroup } from './approval-tree-admin-group';
import { ApprovalTreeAdminGroupLog } from './approval-tree-admin-group-log';
import { ApprovalTreeUserGroup } from './approval-tree-user-group';
import { AuthNetSubmission } from './auth-net-submission';
import { BudgetProductTypeTag } from './budget-product-type-tag';
import { BudgetProductTypeTagMap } from './budget-product-type-tag-map';
import { CancellationReasonType } from './cancellation-reason-type';
import { CancellationRequest } from './cancellation-request';
import { CancellationRequestDetail } from './cancellation-request-detail';
import { CancellationRequestDetailStatus } from './cancellation-request-detail-status';
import { CancellationRequestNote } from './cancellation-request-note';
import { CancellationRequestStatus } from './cancellation-request-status';
import { CatalogFeed } from './catalog-feed';
import { CatalogFeedRun } from './catalog-feed-run';
import { ChangeLog } from './change-log';
import { CollectionScope } from './collection-scope';
import { DocSubmitType } from './doc-submit-type';
import { ImportAccountUserDto } from './import-account-user-dto';
import { InvoiceSummaryDto } from './invoice-summary-dto';
import { JobOrderSummaryDto } from './job-order-summary-dto';
import { NarrativeUserGroupDto } from './narrative-user-group-dto';
import { DurationUnitOfMeasure } from './duration-unit-of-measure';
import { Email } from './email';
import { Feature } from './feature';
import { FeatureChoice } from './feature-choice';
import { Gender } from './gender';
import { GlobalAdmin } from './global-admin';
import { HelpItem } from './help-item';
import { InAppNotification } from './in-app-notification';
import { JobOrder } from './job-order';
import { JobOrderBudgetLog } from './job-order-budget-log';
import { JobOrderDetail } from './job-order-detail';
import { JobOrderDetailAddon } from './job-order-detail-addon';
import { JobOrderHistDetail } from './job-order-hist-detail';
import { JobOrderHistDetailAddon } from './job-order-hist-detail-addon';
import { JobOrderHistDetailFeature } from './job-order-hist-detail-feature';
import { JobOrderHistDetailReceipt } from './job-order-hist-detail-receipt';
import { JobOrderNote } from './job-order-note';
import { JobOrderNoteType } from './job-order-note-type';
import { JobOrderOveragePayment } from './job-order-overage-payment';
import { JobOrderOveragePaymentStatus } from './job-order-overage-payment-status';
import { JobOrderStatus } from './job-order-status';
import { JobOrderType } from './job-order-type';
import { Kit } from './kit';
import { KitDetail } from './kit-detail';
import { KitTag } from './kit-tag';
import { LogType } from './log-type';
import { Manifest } from './manifest';
import { Manufacturer } from './manufacturer';
import { ManufacturerFeedStatus } from './manufacturer-feed-status';
import { ManufacturerImage } from './manufacturer-image';
import { NotificationEvent } from './notification-event';
import { NotificationEventAccountMap } from './notification-event-account-map';
import { NotificationQuery } from './notification-query';
import { NotificationStatus } from './notification-status';
import { NotificationSubmission } from './notification-submission';
import { NotificationTemplate } from './notification-template';
import { NotificationType } from './notification-type';
import { PlannerTaskSubmission } from './planner-task-submission';
import { PricedAddon } from './priced-addon';
import { PricedProductType } from './priced-product-type';
import { PricedProductTypeFeatureChoice } from './priced-product-type-feature-choice';
import { Product } from './product';
import { ProductFeatureChoice } from './product-feature-choice';
import { ProductReplacement } from './product-replacement';
import { ProductType } from './product-type';
import { ProductTypeConfig } from './product-type-config';
import { ProductTypeConfigAddon } from './product-type-config-addon';
import { ProductTypeConfigProduct } from './product-type-config-product';
import { ProductTypeFeature } from './product-type-feature';
import { ProductTypeImage } from './product-type-image';
import { ProductTypeTag } from './product-type-tag';
import { ProductTypeTagMap } from './product-type-tag-map';
import { ProductTypeVersion } from './product-type-version';
import { Program } from './program';
import { ProgramAccountIssuanceMap } from './program-account-issuance-map';
import { ProgramAllowance } from './program-allowance';
import { ProgramAllowanceAddonException } from './program-allowance-addon-exception';
import { ProgramAllowanceFeatureException } from './program-allowance-feature-exception';
import { ProgramAllowanceRemainderRule } from './program-allowance-remainder-rule';
import { ProgramAllowanceUserGroupMap } from './program-allowance-user-group-map';
import { ProgramAllowanceUserLog } from './program-allowance-user-log';
import { ProgramBillingConfig } from './program-billing-config';
import { ProgramBudget } from './program-budget';
import { ProgramByAccountUserSummary } from './program-by-account-user-summary';
import { ProgramIssuance } from './program-issuance';
import { ProgramIssuanceUserGroupMap } from './program-issuance-user-group-map';
import { ProgramIssuanceUserLog } from './program-issuance-user-log';
import { ProgramKit } from './program-kit';
import { ProgramKitIssuance } from './program-kit-issuance';
import { ProgramKitIssuanceUserGroupMap } from './program-kit-issuance-user-group-map';
import { ProgramKitTagMap } from './program-kit-tag-map';
import { ProgramPcardType } from './program-pcard-type';
import { ProgramProductCategoryTag } from './program-product-category-tag';
import { ProgramProductCategoryTagMap } from './program-product-category-tag-map';
import { ProgramProductTypeConfig } from './program-product-type-config';
import { ProgramProductTypeTag } from './program-product-type-tag';
import { ProgramProductTypeTagMap } from './program-product-type-tag-map';
import { ProgramPurchaseOrderType } from './program-purchase-order-type';
import { ProgramRapidTemplate } from './program-rapid-template';
import { ProgramRapidTemplateProductTypeConfig } from './program-rapid-template-product-type-config';
import { ProgramRequirement } from './program-requirement';
import { ProgramRequirementSource } from './program-requirement-source';
import { ProgramReview } from './program-review';
import { ProgramReviewFinding } from './program-review-finding';
import { ProgramStartDateType } from './program-start-date-type';
import { ProgramSupplier } from './program-supplier';
import { ProgramType } from './program-type';
import { ProgramUserGroup } from './program-user-group';
import { ProgramUserGroupBudget } from './program-user-group-budget';
import { ProgramUserGroupExclusion } from './program-user-group-exclusion';
import { ProgramUserGroupMap } from './program-user-group-map';
import { ProgramView } from './program-view';
import { ProgramViewProductTypeConfig } from './program-view-product-type-config';
import { ProgramViolationRule } from './program-violation-rule';
import { ProximityArea } from './proximity-area';
import { ProximityPref } from './proximity-pref';
import { ProximityRight } from './proximity-right';
import { ProximityRole } from './proximity-role';
import { ProximityRoleRightMap } from './proximity-role-right-map';
import { ProximityUser } from './proximity-user';
import { ProximityUserNote } from './proximity-user-note';
import { ReturnPolicy } from './return-policy';
import { ReturnReason } from './return-reason';
import { ReturnReasonType } from './return-reason-type';
import { ReturnRequest } from './return-request';
import { ReturnRequestDetail } from './return-request-detail';
import { ReturnRequestDetailStatus } from './return-request-detail-status';
import { ReturnRequestNote } from './return-request-note';
import { ReturnRequestStatus } from './return-request-status';
import { ReviewGuideline } from './review-guideline';
import { ReviewGuidelineKind } from './review-guideline-kind';
import { ReviewResolution } from './review-resolution';
import { ReviewSeverity } from './review-severity';
import { ShipFrequency } from './ship-frequency';
import { ShippingUserGroup } from './shipping-user-group';
import { ShippingUserGroupAddressMap } from './shipping-user-group-address-map';
import { ShippingUserGroupMap } from './shipping-user-group-map';
import { SizeLabel } from './size-label';
import { SmsTemplate } from './sms-template';
import { StagedSupplierImage } from './staged-supplier-image';
import { StockCondition } from './stock-condition';
import { Supplier } from './supplier';
import { SupplierAccount } from './supplier-account';
import { SupplierAdmin } from './supplier-admin';
import { SupplierCategory } from './supplier-category';
import { SupplierCategoryMap } from './supplier-category-map';
import { SupplierImage } from './supplier-image';
import { SupplierImageRole } from './supplier-image-role';
import { SupplierInventoryApproval } from './supplier-inventory-approval';
import { SupplierSubmission } from './supplier-submission';
import { SupplierSubmissionStatus } from './supplier-submission-status';
import { TemplateVariable } from './template-variable';
import { UnwindEvent } from './unwind-event';

export class ProximityRegistrationHelper {

    static register(metadataStore: MetadataStore) {
        metadataStore.registerEntityTypeCtor('Account', Account);
        metadataStore.registerEntityTypeCtor('AccountAddress', AccountAddress);
        metadataStore.registerEntityTypeCtor('AccountAdmin', AccountAdmin);
        metadataStore.registerEntityTypeCtor('AccountAdminGroup', AccountAdminGroup);
        metadataStore.registerEntityTypeCtor('AccountAdminGroupMap', AccountAdminGroupMap);
        metadataStore.registerEntityTypeCtor('AccountBudget', AccountBudget);
        metadataStore.registerEntityTypeCtor('AccountConsolidation', AccountConsolidation);
        metadataStore.registerEntityTypeCtor('AccountConsolidationDecision', AccountConsolidationDecision);
        metadataStore.registerEntityTypeCtor('AccountConsolidationItem', AccountConsolidationItem);
        metadataStore.registerEntityTypeCtor('AccountConsolidationItemType', AccountConsolidationItemType);
        metadataStore.registerEntityTypeCtor('AccountConsolidationStatus', AccountConsolidationStatus);
        metadataStore.registerEntityTypeCtor('AccountGuidelineException', AccountGuidelineException);
        metadataStore.registerEntityTypeCtor('AccountImage', AccountImage);
        metadataStore.registerEntityTypeCtor('AccountImport', AccountImport);
        metadataStore.registerEntityTypeCtor('AccountImportCodeOption', AccountImportCodeOption);
        metadataStore.registerEntityTypeCtor('AccountIssuance', AccountIssuance);
        metadataStore.registerEntityTypeCtor('AccountIssuanceUserGroupMap', AccountIssuanceUserGroupMap);
        metadataStore.registerEntityTypeCtor('AccountIssuanceUserLog', AccountIssuanceUserLog);
        metadataStore.registerEntityTypeCtor('AccountProcurementCard', AccountProcurementCard);
        metadataStore.registerEntityTypeCtor('AccountProcurementCardLog', AccountProcurementCardLog);
        metadataStore.registerEntityTypeCtor('AccountPurchaseOrder', AccountPurchaseOrder);
        metadataStore.registerEntityTypeCtor('AccountPurchaseOrderLog', AccountPurchaseOrderLog);
        metadataStore.registerEntityTypeCtor('AccountUser', AccountUser);
        metadataStore.registerEntityTypeCtor('AccountUserAllowanceLog', AccountUserAllowanceLog);
        metadataStore.registerEntityTypeCtor('ActiveStatus', ActiveStatus);
        metadataStore.registerEntityTypeCtor('Addon', Addon);
        metadataStore.registerEntityTypeCtor('AddonImage', AddonImage);
        metadataStore.registerEntityTypeCtor('ApiCombinePair', ApiCombinePair);
        metadataStore.registerEntityTypeCtor('ApprovalTree', ApprovalTree);
        metadataStore.registerEntityTypeCtor('ApprovalTreeAdminGroup', ApprovalTreeAdminGroup);
        metadataStore.registerEntityTypeCtor('ApprovalTreeAdminGroupLog', ApprovalTreeAdminGroupLog);
        metadataStore.registerEntityTypeCtor('ApprovalTreeUserGroup', ApprovalTreeUserGroup);
        metadataStore.registerEntityTypeCtor('AuthNetSubmission', AuthNetSubmission);
        metadataStore.registerEntityTypeCtor('BudgetProductTypeTag', BudgetProductTypeTag);
        metadataStore.registerEntityTypeCtor('BudgetProductTypeTagMap', BudgetProductTypeTagMap);
        metadataStore.registerEntityTypeCtor('CancellationReasonType', CancellationReasonType);
        metadataStore.registerEntityTypeCtor('CancellationRequest', CancellationRequest);
        metadataStore.registerEntityTypeCtor('CancellationRequestDetail', CancellationRequestDetail);
        metadataStore.registerEntityTypeCtor('CancellationRequestDetailStatus', CancellationRequestDetailStatus);
        metadataStore.registerEntityTypeCtor('CancellationRequestNote', CancellationRequestNote);
        metadataStore.registerEntityTypeCtor('CancellationRequestStatus', CancellationRequestStatus);
        metadataStore.registerEntityTypeCtor('CatalogFeed', CatalogFeed);
        metadataStore.registerEntityTypeCtor('CatalogFeedRun', CatalogFeedRun);
        metadataStore.registerEntityTypeCtor('ChangeLog', ChangeLog);
        metadataStore.registerEntityTypeCtor('CollectionScope', CollectionScope);
        metadataStore.registerEntityTypeCtor('DocSubmitType', DocSubmitType);
        metadataStore.registerEntityTypeCtor('ImportAccountUserDto', ImportAccountUserDto);
        metadataStore.registerEntityTypeCtor('InvoiceSummaryDto', InvoiceSummaryDto);
        metadataStore.registerEntityTypeCtor('JobOrderSummaryDto', JobOrderSummaryDto);
        metadataStore.registerEntityTypeCtor('NarrativeUserGroupDto', NarrativeUserGroupDto);
        metadataStore.registerEntityTypeCtor('DurationUnitOfMeasure', DurationUnitOfMeasure);
        metadataStore.registerEntityTypeCtor('Email', Email);
        metadataStore.registerEntityTypeCtor('Feature', Feature);
        metadataStore.registerEntityTypeCtor('FeatureChoice', FeatureChoice);
        metadataStore.registerEntityTypeCtor('Gender', Gender);
        metadataStore.registerEntityTypeCtor('GlobalAdmin', GlobalAdmin);
        metadataStore.registerEntityTypeCtor('HelpItem', HelpItem);
        metadataStore.registerEntityTypeCtor('InAppNotification', InAppNotification);
        metadataStore.registerEntityTypeCtor('JobOrder', JobOrder);
        metadataStore.registerEntityTypeCtor('JobOrderBudgetLog', JobOrderBudgetLog);
        metadataStore.registerEntityTypeCtor('JobOrderDetail', JobOrderDetail);
        metadataStore.registerEntityTypeCtor('JobOrderDetailAddon', JobOrderDetailAddon);
        metadataStore.registerEntityTypeCtor('JobOrderHistDetail', JobOrderHistDetail);
        metadataStore.registerEntityTypeCtor('JobOrderHistDetailAddon', JobOrderHistDetailAddon);
        metadataStore.registerEntityTypeCtor('JobOrderHistDetailFeature', JobOrderHistDetailFeature);
        metadataStore.registerEntityTypeCtor('JobOrderHistDetailReceipt', JobOrderHistDetailReceipt);
        metadataStore.registerEntityTypeCtor('JobOrderNote', JobOrderNote);
        metadataStore.registerEntityTypeCtor('JobOrderNoteType', JobOrderNoteType);
        metadataStore.registerEntityTypeCtor('JobOrderOveragePayment', JobOrderOveragePayment);
        metadataStore.registerEntityTypeCtor('JobOrderOveragePaymentStatus', JobOrderOveragePaymentStatus);
        metadataStore.registerEntityTypeCtor('JobOrderStatus', JobOrderStatus);
        metadataStore.registerEntityTypeCtor('JobOrderType', JobOrderType);
        metadataStore.registerEntityTypeCtor('Kit', Kit);
        metadataStore.registerEntityTypeCtor('KitDetail', KitDetail);
        metadataStore.registerEntityTypeCtor('KitTag', KitTag);
        metadataStore.registerEntityTypeCtor('LogType', LogType);
        metadataStore.registerEntityTypeCtor('Manifest', Manifest);
        metadataStore.registerEntityTypeCtor('Manufacturer', Manufacturer);
        metadataStore.registerEntityTypeCtor('ManufacturerFeedStatus', ManufacturerFeedStatus);
        metadataStore.registerEntityTypeCtor('ManufacturerImage', ManufacturerImage);
        metadataStore.registerEntityTypeCtor('NotificationEvent', NotificationEvent);
        metadataStore.registerEntityTypeCtor('NotificationEventAccountMap', NotificationEventAccountMap);
        metadataStore.registerEntityTypeCtor('NotificationQuery', NotificationQuery);
        metadataStore.registerEntityTypeCtor('NotificationStatus', NotificationStatus);
        metadataStore.registerEntityTypeCtor('NotificationSubmission', NotificationSubmission);
        metadataStore.registerEntityTypeCtor('NotificationTemplate', NotificationTemplate);
        metadataStore.registerEntityTypeCtor('NotificationType', NotificationType);
        metadataStore.registerEntityTypeCtor('PlannerTaskSubmission', PlannerTaskSubmission);
        metadataStore.registerEntityTypeCtor('PricedAddon', PricedAddon);
        metadataStore.registerEntityTypeCtor('PricedProductType', PricedProductType);
        metadataStore.registerEntityTypeCtor('PricedProductTypeFeatureChoice', PricedProductTypeFeatureChoice);
        metadataStore.registerEntityTypeCtor('Product', Product);
        metadataStore.registerEntityTypeCtor('ProductFeatureChoice', ProductFeatureChoice);
        metadataStore.registerEntityTypeCtor('ProductReplacement', ProductReplacement);
        metadataStore.registerEntityTypeCtor('ProductType', ProductType);
        metadataStore.registerEntityTypeCtor('ProductTypeConfig', ProductTypeConfig);
        metadataStore.registerEntityTypeCtor('ProductTypeConfigAddon', ProductTypeConfigAddon);
        metadataStore.registerEntityTypeCtor('ProductTypeConfigProduct', ProductTypeConfigProduct);
        metadataStore.registerEntityTypeCtor('ProductTypeFeature', ProductTypeFeature);
        metadataStore.registerEntityTypeCtor('ProductTypeImage', ProductTypeImage);
        metadataStore.registerEntityTypeCtor('ProductTypeTag', ProductTypeTag);
        metadataStore.registerEntityTypeCtor('ProductTypeTagMap', ProductTypeTagMap);
        metadataStore.registerEntityTypeCtor('ProductTypeVersion', ProductTypeVersion);
        metadataStore.registerEntityTypeCtor('Program', Program);
        metadataStore.registerEntityTypeCtor('ProgramAccountIssuanceMap', ProgramAccountIssuanceMap);
        metadataStore.registerEntityTypeCtor('ProgramAllowance', ProgramAllowance);
        metadataStore.registerEntityTypeCtor('ProgramAllowanceAddonException', ProgramAllowanceAddonException);
        metadataStore.registerEntityTypeCtor('ProgramAllowanceFeatureException', ProgramAllowanceFeatureException);
        metadataStore.registerEntityTypeCtor('ProgramAllowanceRemainderRule', ProgramAllowanceRemainderRule);
        metadataStore.registerEntityTypeCtor('ProgramAllowanceUserGroupMap', ProgramAllowanceUserGroupMap);
        metadataStore.registerEntityTypeCtor('ProgramAllowanceUserLog', ProgramAllowanceUserLog);
        metadataStore.registerEntityTypeCtor('ProgramBillingConfig', ProgramBillingConfig);
        metadataStore.registerEntityTypeCtor('ProgramBudget', ProgramBudget);
        metadataStore.registerEntityTypeCtor('ProgramByAccountUserSummary', ProgramByAccountUserSummary);
        metadataStore.registerEntityTypeCtor('ProgramIssuance', ProgramIssuance);
        metadataStore.registerEntityTypeCtor('ProgramIssuanceUserGroupMap', ProgramIssuanceUserGroupMap);
        metadataStore.registerEntityTypeCtor('ProgramIssuanceUserLog', ProgramIssuanceUserLog);
        metadataStore.registerEntityTypeCtor('ProgramKit', ProgramKit);
        metadataStore.registerEntityTypeCtor('ProgramKitIssuance', ProgramKitIssuance);
        metadataStore.registerEntityTypeCtor('ProgramKitIssuanceUserGroupMap', ProgramKitIssuanceUserGroupMap);
        metadataStore.registerEntityTypeCtor('ProgramKitTagMap', ProgramKitTagMap);
        metadataStore.registerEntityTypeCtor('ProgramPcardType', ProgramPcardType);
        metadataStore.registerEntityTypeCtor('ProgramProductCategoryTag', ProgramProductCategoryTag);
        metadataStore.registerEntityTypeCtor('ProgramProductCategoryTagMap', ProgramProductCategoryTagMap);
        metadataStore.registerEntityTypeCtor('ProgramProductTypeConfig', ProgramProductTypeConfig);
        metadataStore.registerEntityTypeCtor('ProgramProductTypeTag', ProgramProductTypeTag);
        metadataStore.registerEntityTypeCtor('ProgramProductTypeTagMap', ProgramProductTypeTagMap);
        metadataStore.registerEntityTypeCtor('ProgramPurchaseOrderType', ProgramPurchaseOrderType);
        metadataStore.registerEntityTypeCtor('ProgramRapidTemplate', ProgramRapidTemplate);
        metadataStore.registerEntityTypeCtor('ProgramRapidTemplateProductTypeConfig', ProgramRapidTemplateProductTypeConfig);
        metadataStore.registerEntityTypeCtor('ProgramRequirement', ProgramRequirement);
        metadataStore.registerEntityTypeCtor('ProgramRequirementSource', ProgramRequirementSource);
        metadataStore.registerEntityTypeCtor('ProgramReview', ProgramReview);
        metadataStore.registerEntityTypeCtor('ProgramReviewFinding', ProgramReviewFinding);
        metadataStore.registerEntityTypeCtor('ProgramStartDateType', ProgramStartDateType);
        metadataStore.registerEntityTypeCtor('ProgramSupplier', ProgramSupplier);
        metadataStore.registerEntityTypeCtor('ProgramType', ProgramType);
        metadataStore.registerEntityTypeCtor('ProgramUserGroup', ProgramUserGroup);
        metadataStore.registerEntityTypeCtor('ProgramUserGroupBudget', ProgramUserGroupBudget);
        metadataStore.registerEntityTypeCtor('ProgramUserGroupExclusion', ProgramUserGroupExclusion);
        metadataStore.registerEntityTypeCtor('ProgramUserGroupMap', ProgramUserGroupMap);
        metadataStore.registerEntityTypeCtor('ProgramView', ProgramView);
        metadataStore.registerEntityTypeCtor('ProgramViewProductTypeConfig', ProgramViewProductTypeConfig);
        metadataStore.registerEntityTypeCtor('ProgramViolationRule', ProgramViolationRule);
        metadataStore.registerEntityTypeCtor('ProximityArea', ProximityArea);
        metadataStore.registerEntityTypeCtor('ProximityPref', ProximityPref);
        metadataStore.registerEntityTypeCtor('ProximityRight', ProximityRight);
        metadataStore.registerEntityTypeCtor('ProximityRole', ProximityRole);
        metadataStore.registerEntityTypeCtor('ProximityRoleRightMap', ProximityRoleRightMap);
        metadataStore.registerEntityTypeCtor('ProximityUser', ProximityUser);
        metadataStore.registerEntityTypeCtor('ProximityUserNote', ProximityUserNote);
        metadataStore.registerEntityTypeCtor('ReturnPolicy', ReturnPolicy);
        metadataStore.registerEntityTypeCtor('ReturnReason', ReturnReason);
        metadataStore.registerEntityTypeCtor('ReturnReasonType', ReturnReasonType);
        metadataStore.registerEntityTypeCtor('ReturnRequest', ReturnRequest);
        metadataStore.registerEntityTypeCtor('ReturnRequestDetail', ReturnRequestDetail);
        metadataStore.registerEntityTypeCtor('ReturnRequestDetailStatus', ReturnRequestDetailStatus);
        metadataStore.registerEntityTypeCtor('ReturnRequestNote', ReturnRequestNote);
        metadataStore.registerEntityTypeCtor('ReturnRequestStatus', ReturnRequestStatus);
        metadataStore.registerEntityTypeCtor('ReviewGuideline', ReviewGuideline);
        metadataStore.registerEntityTypeCtor('ReviewGuidelineKind', ReviewGuidelineKind);
        metadataStore.registerEntityTypeCtor('ReviewResolution', ReviewResolution);
        metadataStore.registerEntityTypeCtor('ReviewSeverity', ReviewSeverity);
        metadataStore.registerEntityTypeCtor('ShipFrequency', ShipFrequency);
        metadataStore.registerEntityTypeCtor('ShippingUserGroup', ShippingUserGroup);
        metadataStore.registerEntityTypeCtor('ShippingUserGroupAddressMap', ShippingUserGroupAddressMap);
        metadataStore.registerEntityTypeCtor('ShippingUserGroupMap', ShippingUserGroupMap);
        metadataStore.registerEntityTypeCtor('SizeLabel', SizeLabel);
        metadataStore.registerEntityTypeCtor('SmsTemplate', SmsTemplate);
        metadataStore.registerEntityTypeCtor('StagedSupplierImage', StagedSupplierImage);
        metadataStore.registerEntityTypeCtor('StockCondition', StockCondition);
        metadataStore.registerEntityTypeCtor('Supplier', Supplier);
        metadataStore.registerEntityTypeCtor('SupplierAccount', SupplierAccount);
        metadataStore.registerEntityTypeCtor('SupplierAdmin', SupplierAdmin);
        metadataStore.registerEntityTypeCtor('SupplierCategory', SupplierCategory);
        metadataStore.registerEntityTypeCtor('SupplierCategoryMap', SupplierCategoryMap);
        metadataStore.registerEntityTypeCtor('SupplierImage', SupplierImage);
        metadataStore.registerEntityTypeCtor('SupplierImageRole', SupplierImageRole);
        metadataStore.registerEntityTypeCtor('SupplierInventoryApproval', SupplierInventoryApproval);
        metadataStore.registerEntityTypeCtor('SupplierSubmission', SupplierSubmission);
        metadataStore.registerEntityTypeCtor('SupplierSubmissionStatus', SupplierSubmissionStatus);
        metadataStore.registerEntityTypeCtor('TemplateVariable', TemplateVariable);
        metadataStore.registerEntityTypeCtor('UnwindEvent', UnwindEvent);
    }
}
